import { WidthContainer } from '@pata-app/ui-document';

import React from 'react';

import SectionContainer from '../../../../components/sectionContainer/sectionContainer';
import { HighlightContent } from '../../../businessFeatures/components/heroSection/heroSection.styled';
import { FEATURES_CONFIG } from '../../businessCompetitors.config';
import { FeatureSection } from './featureSection';
import { SectionHeading } from './featureSection.styled';

interface FeaturesSectionProps {
  featuresTitle: string;
  featuresTiles: string[];
}

export function FeaturesSection({ featuresTitle, featuresTiles }: FeaturesSectionProps) {
  return (
    <>
      <WidthContainer />
      <WidthContainer noBackground>
        <SectionHeading>{featuresTitle}</SectionHeading>
      </WidthContainer>

      {featuresTiles.map((featureSection, index) => (
        <WidthContainer>
          <SectionContainer id={featureSection.id}>
            <FeatureSection key={featureSection.id} featureSection={featureSection} rightAligned={index % 2 === 0} />
          </SectionContainer>
        </WidthContainer>
      ))}
    </>
  );
}
